IREP.meetTheTeam = (function() {
    var init = function() {
        var TeamDisplay = true;
        var TeamSize = $('#TeamHolder').offset().top;

        CSSPlugin.defaultTransformPerspective = 600;

        var count = 1,
        masterTL = new TimelineMax({ repeat: -1, yoyo: false }),
               tl1 = new TimelineMax({ delay: 0 }),//There'll be at least one timeline

        ticks = $("div.tick"),
        ticksAmount = ticks.length,
        setAmount = 3,//This number sets how many elements will be animated on each cycle

        //This array will contain the nested timelines.
        lineArray = [tl1];

        masterTL.add(tl1).timeScale(3.5)// Adding the first timeline to the parent one



        $.each($("div.tick"), function (index, element) {

            //Adding the current element to the last timeline of the array
            lineArray[count - 1].from(element, 3.0, { rotationY: -100, transformOrigin: "left 50% -200", opacity: 0, display: "none" });

            if ((index % setAmount) == (setAmount - 1)) {
                //This gets the DOM elements of the timeline to tween their opacity
                var lineTargets = getLineTargets(lineArray[count - 1]);
                lineArray[count - 1].staggerTo(lineTargets, 3.0, { rotationY: 100, transformOrigin: "left 50% -400", opacity: 0, delay: 2.5 }, 2.0);
                +lineArray[count - 1].staggerTo(lineTargets, 3.0, { display: "none", delay: 2.5 }, 2.0);

                //Create a new timeline once the last on of the array has the number of elements set for each cycle
                count++;
                var newLine = 'tl' + count;
                lineArray.push(newLine);
                lineArray[count - 1] = new TimelineMax({ delay: 0 });//this is now the last timeline of the array
                masterTL.add(lineArray[count - 1]);//we add the timeline to the parent one
            }

            //if the amount of elements can't be divided by the cycle number run this code when the loop is at the last element
            if (index == (ticksAmount - 1)) {
                //if the number of elements can be divided by the amount of each cycle this array comes empty
                var lineTargets = getLineTargets(lineArray[count - 1]);
                lineArray[count - 1].to({}, 0, {}).staggerTo(lineTargets, 3.0, { rotationY: 100, transformOrigin: "left 50% -400", opacity: 0, delay: 2.5 }, 2.0);
            }

        });
    };

    var getLineTargets = function(tween) {
        var nestedTweens = tween.getChildren(),
                tweenTargets = [];
        $.each(nestedTweens, function (index, element) {
            tweenTargets.push(element.target);
        });
        return tweenTargets;
    };

    return {
        init: init
    };
})();

IREP.meetTheTeamPage = (function () {
    var init = function () {
        $(".divEmptyDesc").each(function () {
            var id = this.id.substring(9, (this.id.length));
            $('#Description' + id).slideDown(2000);
            $('#EmptyDesc' + id).slideUp(2000);

        });
    };
    $('.ArrowClicked').click(function () {
        var id = this.id.substring(8, (this.id.length));
        if (document.getElementById('imgArrow' + id).src.indexOf("Content/images/MeetTheTeam/arrowup.jpg") != -1) {
            document.getElementById('imgArrow' + id).src = "../Content/images/MeetTheTeam/arrowdown.jpg";
            $('#EmptyDesc' + id).slideDown("slow");
            $('#Description' + id).slideUp("slow");
        }
        else {
            document.getElementById('imgArrow' + id).src = "../Content/images/MeetTheTeam/arrowup.jpg";
            $('#Description' + id).slideDown("slow");
            $('#EmptyDesc' + id).slideUp("slow");
        }
        $('#Map' + id).slideToggle("slow");
    });
    return {
        init: init
    };
})();